/* eslint-disable no-undef */
import React from 'react';
import { getId } from '@core/js/hooks/device';
import * as pas from '@core/js/hooks/auth/pas';
import { dispatcher } from '@core/js/backbone/dispatcher';
import { registerPortlets } from '@core/js/backbone/portlets';
import { send } from 'server';
import { getUserAgent } from '@core/js/utils/device.util';
import { render, unmountComponentAtNode } from 'react-dom';
import { scrollService } from '@core/js/services/scroll.service';
import { ReCaptchaBare, ERRORS } from '@core/js/components/main/ReCaptcha';
import { addBackUrls } from '@core/js/components/main/QuickDeposit/Deposit/helpers';
import { performRedirect } from '@core/js/components/main/QuickDeposit/utils/redirect';
import * as luxon from 'luxon';

export { luxon };
export { pas };
export { dispatcher };
export { getUserAgent };
export { registerPortlets };
export { send };

export const getDeviceId = () => getId();
export const cashier = {
    addBackUrls,
    performRedirect
};
export const {
    enableBodyScroll,
    disableBodyScroll
} = scrollService;
export const unmountApp = (selector) => unmountComponentAtNode(document.querySelector(selector));

export const reCaptcha = selector => ({
    render: options => render(<ReCaptchaBare {...options} />, document.querySelector(selector)),
    remove: () => unmountComponentAtNode(document.querySelector(selector)),
    ERRORS
});
